module.exports = __webpack_public_path__ + "img/weather58.355d8255.png";